import { useEffect, useState } from "react";

const HEX = "0123456789ABCDEF";
const randHex = (n) => Array.from({ length: n }, () => HEX[Math.floor(Math.random() * 16)]).join("");

export const DecodingAnimation = ({ label = "decoding audio signature" }) => {
  const [line1, setLine1] = useState(randHex(24));
  const [line2, setLine2] = useState(randHex(24));
  const [line3, setLine3] = useState(randHex(24));

  useEffect(() => {
    const t = setInterval(() => {
      setLine1(randHex(24));
      setLine2(randHex(24));
      setLine3(randHex(24));
    }, 120);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="border border-emerald-500/30 bg-zinc-950/60 p-8 rounded-sm" data-testid="decoding-animation">
      <div className="flex items-center gap-2 mb-6">
        <div className="w-2 h-2 bg-emerald-500 flicker" />
        <span className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-emerald-500">
          {label}
        </span>
      </div>

      {/* Waveform bars */}
      <div className="flex items-end justify-center gap-1 h-24 mb-6">
        {Array.from({ length: 40 }).map((_, i) => (
          <div
            key={i}
            className="wave-bar"
            style={{
              height: `${Math.random() * 100}%`,
              animationDelay: `${i * 0.04}s`,
              animationDuration: `${0.6 + Math.random() * 0.6}s`,
            }}
          />
        ))}
      </div>

      {/* Faux data stream */}
      <div className="space-y-1.5 font-mono-display text-[11px] text-emerald-500/70">
        <div className="flex gap-4">
          <span className="text-zinc-600">01</span>
          <span className="tracking-widest">{line1}</span>
          <span className="text-zinc-600 ml-auto">FFT</span>
        </div>
        <div className="flex gap-4">
          <span className="text-zinc-600">02</span>
          <span className="tracking-widest">{line2}</span>
          <span className="text-zinc-600 ml-auto">BPM</span>
        </div>
        <div className="flex gap-4">
          <span className="text-zinc-600">03</span>
          <span className="tracking-widest">{line3}</span>
          <span className="text-zinc-600 ml-auto">MFCC</span>
        </div>
      </div>

      <div className="mt-6 pt-4 border-t border-white/5 flex justify-between font-mono-display text-[10px] tracking-[0.2em] uppercase text-zinc-500">
        <span>gemini_3.1_pro</span>
        <span className="text-emerald-500/60">processing...</span>
      </div>
    </div>
  );
};
